import * as React from 'react';

import { Grid, Skeleton } from '@emburse/ui-core';

interface ILoadingSkeletonProps {
  className?: string;
  containerStyleProps?: React.CSSProperties;
  marginTop: React.CSSProperties['marginTop'];
}

/**
 * Generic page-aligned skeleton block for loading states that need preserved content spacing.
 */
export const LoadingSkeleton: React.FC<ILoadingSkeletonProps> = ({ className, containerStyleProps = {}, marginTop }) => {
  return (
    <Grid container direction="column" sx={{ height: '100%', maxWidth: '1270px' }} wrap="nowrap" className={className}>
      <Grid item style={{ marginTop, paddingLeft: '32px', paddingRight: '32px', minWidth: '1090px', ...containerStyleProps }}>
        <Skeleton height={200} variant="rect" data-testid={'loading-skeleton'} />
      </Grid>
    </Grid>
  );
};
